import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployeeAverageAgeListType } from 'types/kodawari';

/**
 * 社員の平均年齢に関するカスタムフック
 * @param initialEmployeeAverageAgeData
 * @returns 社員の平均年齢の値と更新する関数を含むオブジェクト
 */
export const useEmployeeAverageAge = (
  initialEmployeeAverageAgeData: EmployeeAverageAgeListType[]
) => {
  const [employeeAverageAgeList, setEmployeeAverageAgeList] = useState<
    EmployeeAverageAgeListType[]
  >(initialEmployeeAverageAgeData);

  const selectedEmployeeAverageAgeList = employeeAverageAgeList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value);

  // チェック状態更新処理
  const updateIsCheckedEmployeeAverageAgeList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = employeeAverageAgeList.map((item) => {
      if (item.value !== event.target.value) return item;

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setEmployeeAverageAgeList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  };

  // 求人件数更新処理
  const updateEmployeeAverageAgeListJobCount = (
    employeeAverageAgeJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setEmployeeAverageAgeList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(employeeAverageAgeJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedEmployeeAverageAgeList = () => {
    const checkedList = employeeAverageAgeList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setEmployeeAverageAgeList(checkedList);
  };

  return {
    employeeAverageAgeList,
    selectedEmployeeAverageAgeList,
    updateIsCheckedEmployeeAverageAgeList,
    updateEmployeeAverageAgeListJobCount,
    clearIsCheckedEmployeeAverageAgeList,
  };
};
